import { ReactNode } from 'react';
import { NsForm as BgNsForm } from '@britishgasenergy/react-nucleus/dist/nuc-components/NsForm';
import { FormContext } from 'components/common/ns-form/context/FormContext';

export type Field = {
  name: string;
  isValid: boolean;
  error: string | undefined;
  input: HTMLElement;
  value: string;
};

export type ValidationState = {
  error: string | undefined;
  name: string;
  value: string;
  isValid: boolean;
  validity: ValidityState;
  formElement: HTMLElement;
};

export type ValidationResult = {
  isValid: boolean;
  fields: Field[];
  fieldsByName: Record<string, Field>;
  validationStates: Array<ValidationState>;
};

type NsFormProps = {
  onSubmit?: (
    event: React.FormEvent<HTMLFormElement>,
    validation: ValidationResult
  ) => void;
  onValidated?: () => void;
  testId?: string;
  children?: ReactNode;
  id?: string;
};

export const NsForm = ({
  onSubmit = () => {},
  onValidated = () => {},
  testId,
  id,
  children
}: NsFormProps) => {
  const submitHandler = async (event) => {
    const validation = event.target.validate();
    const { isValid, validationStates } = validation;

    // compat fixes for https://teams.microsoft.com/l/message/19:106c13b4eda84e8b823155e88fe15536@thread.tacv2/1697702797561?tenantId=a603898f-7de2-45ba-b67d-d35fb519b2cf&groupId=1f9c2411-216b-42a8-9bb0-c51f28ff5071&parentMessageId=1697702797561&teamName=Nucleus%20Design%20System%20%E2%9A%9B&channelName=%F0%9F%93%AB%20Questions%20and%20Feedback&createdTime=1697702797561&allowXTenantAccess=false
    let newValidation = { ...validation };
    newValidation = {
      ...newValidation,
      fieldsByName: validationStates.reduce((acc, field) => {
        return {
          ...acc,
          [field.name]: field
        };
      }, {})
    };

    newValidation = {
      ...newValidation,
      fields: validationStates
    };
    // end compat fixes

    if (isValid) {
      await onSubmit(event, newValidation);
    }

    return isValid;
  };

  return (
    <div data-testid={testId} id={id}>
      <BgNsForm onSubmit={submitHandler} onValidated={onValidated}>
        <FormContext.Provider value={true}>{children}</FormContext.Provider>
      </BgNsForm>
    </div>
  );
};
